<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Blog_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Blog</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <h1 class="subtitle">{{post.titulo}}</h1>
      <div class="date">{{post.data_criacao | date:'dd/MM/yyyy'}}</div>

      <div class="area-share">
        <span>Compartilhar post:</span>
        <ul class="list-share">
          <li><a class="email"
              href="mailto:?subject=&amp;body=Veja este artigo de Union Solutions: https://unionsolutions.com.br/blog/{{post.id}}/{{post.slug}}/"
              target="_blank"><i class="fa fa-envelope"></i></a></li>
          <li><a class="facebook"
              href="https://www.facebook.com/sharer/sharer.php?u=https://unionsolutions.com.br/blog/{{post.id}}/{{post.slug}}/"
              target="_blank"><i class="fab fa-facebook-f"></i></a></li>
          <li><a class="linkedin"
              href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://unionsolutions.com.br/blog/{{post.id}}/{{post.slug}}/&amp;title="><i
                class="fab fa-linkedin-in"></i></a></li>
          <li><a class="whatsapp"
              href="https://web.whatsapp.com/send?text=https://unionsolutions.com.br/blog/{{post.id}}/{{post.slug}}/"
              data-action="share/whatsapp/share" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
        </ul>
      </div>

      <figure class="photo">
        <img width="1080" height="540" src="{{post.link_img}}"
          class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt="{{post.titulo}}" decoding="async"
          fetchpriority="high" sizes="(max-width: 1080px) 100vw, 1080px">
      </figure>
      <div class="postBody" [innerHTML]="post.body"></div>
    </div>
  </section>

  <app-destaque-blog></app-destaque-blog>

</main>


